import { ButtonBase, ClickAwayListener } from "@mui/material";
import React, { useState } from "react";
import { inputButtonStyle } from "../input/inputWrapper";
import {
  DISPLAY,
  JUSTIFY_CONTENT,
  SPACING,
  TEXT_ALIGN,
} from "../../Constants/Enums/styles.enum";
import { Colors } from "../../Constants/colors";
import { DropdownAnchor } from "./DropdownAnchor";

interface IDropdownWrapperProps {
  children({
    isDropdownClicked,
    setDropdownClicked,
  }: {
    isDropdownClicked: boolean;
    setDropdownClicked: (dropDownClicked: boolean) => unknown;
  }): React.ReactNode;
  onClick?: (cb: () => unknown) => unknown;
  selectedOptions?: any[] | null;
}

export const DropdownWrapper = ({
  children,
  onClick,
  selectedOptions = null,
}: IDropdownWrapperProps) => {
  const [dropdownClicked, setDropdownClicked] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleDropdownCloseAction = () => {
    setDropdownClicked(!dropdownClicked);
  };

  const handleDropdownClick = () => {
    setIsFocused(true);
    if (onClick) {
      return onClick(handleDropdownCloseAction);
    }
    handleDropdownCloseAction();
  };

  const getBorderColor = () => {
    if (isFocused || dropdownClicked) return Colors.TangerineOrange;
    if (isHovered) return Colors.Grey;
    return Colors.LightGrey;
  };

  const getBackgroundColor = () => {
    if (dropdownClicked) return Colors.LIGHT_TANGERINE_ORANGE;
    if (isHovered) return Colors.VeryLightGrey;
    return Colors.White;
  };

  return (
    <>
      <style>
        {`
          .dropdown-wrapper-container {
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .dropdown-wrapper-container:focus {
            outline: none;
          }

          .dropdown-divider {
            transition: background-color 0.2s ease;
          }
        `}
      </style>
      <ClickAwayListener
        onClickAway={() => {
          setDropdownClicked(false);
          setIsFocused(false);
        }}
      >
        <ButtonBase
          className="dropdown-wrapper-container"
          style={{
            ...inputButtonStyle,
            height: selectedOptions?.length ? "auto" : "48px",
            minHeight: "48px",
            display: DISPLAY.FLEX,
            justifyContent: JUSTIFY_CONTENT.START,
            textAlign: TEXT_ALIGN.LEFT,
            width: "100%",
            gap: SPACING.S10,
            borderColor: getBorderColor(),
            borderWidth: "2px",
            backgroundColor: getBackgroundColor(),
            boxShadow:
              isFocused || dropdownClicked
                ? `0 0 0 3px ${Colors.LIGHT_TANGERINE_ORANGE}`
                : isHovered
                  ? "0 2px 8px rgba(0, 0, 0, 0.08)"
                  : "none",
          }}
          onClick={handleDropdownClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
            {children({
              isDropdownClicked: dropdownClicked,
              setDropdownClicked,
            })}
          </div>

          <div
            className="dropdown-divider"
            style={{
              width: "1px",
              height: "60%",
              backgroundColor:
                isHovered || isFocused || dropdownClicked
                  ? Colors.TangerineOrange
                  : Colors.LightGrey,
              alignSelf: "center",
            }}
          />

          <DropdownAnchor
            onClick={() => {
              setDropdownClicked(!dropdownClicked);
            }}
            isClicked={dropdownClicked}
          />
        </ButtonBase>
      </ClickAwayListener>
    </>
  );
};
